import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down-big",
  "use": "icon-chevron-down-big-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-chevron-down-big\"><path d=\"M8 11.4 2.9 6.3l.7-.7L8 10l4.4-4.4.7.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol